import { Injectable } from '@angular/core';
import { httpsCallable } from 'firebase/functions';
import { functions } from 'src/app/app.component';

@Injectable({ providedIn: 'root' })
export class UserSettingsService {
  async update(organisationIds: string[], settings: Record<string, unknown>) {
    const updateSettings = httpsCallable(functions, 'httpUpdateOwnUserSettings');
    await updateSettings({ organisationIds, settings });
  }
}
